import { useMutation, useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../../utils/enum";
import axiosInstance from "./axiosInstance";

export interface InvoiceDetailRequest {
    s_bl_kind: "E"; //고정값
    s_bl_no: string;
    s_bl_seq: "001"; //고정값
}
export interface InvoiceDetailResponse {}

export const usePostInvoiceDetail = (successCallback?: (data: InvoiceDetailResponse) => void) => {
    return useMutation({
        mutationFn: async (data: InvoiceDetailRequest) => {
            const response = await axiosInstance.post(enum_api_uri.INVOICE_DETAIL, data);
            return response.data;
        },
        onSuccess: data => {
            successCallback?.(data);
        },
    });
};
